import React from "react";
import AdminModuleConfigurationsRoutes from "./AdminModuleConfigurationsRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminModuleConfigurationsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration ModuleConfigurations",
      page: "Admin ModuleConfigurations Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminModuleConfigurationsRoutes />
      </Track>
    </div>
  );
};

export default AdminModuleConfigurationsScreen;
